/**
 * APP ROUTES - Admin Panel Route Configuration
 *
 * ⚠️ THIS FILE IS NOW AUTO-DERIVED FROM ADMIN_PAGES CONFIG
 *
 * All route definitions are now sourced from:
 *   src/app/services/admin-pages.config.ts
 *
 * To modify routes:
 *   1. Edit ADMIN_PAGES in admin-pages.config.ts
 *   2. Routes are auto-generated via buildRoutes()
 *
 * DO NOT manually add routes here - they will be overwritten.
 */
import { Routes } from '@angular/router';
import { DERIVED_ROUTES } from './services/admin-pages.config';

// Export derived routes as the app's route configuration
export const routes: Routes = DERIVED_ROUTES;
